module.exports = __webpack_public_path__ + "static/media/notifications.43778f78.svg";